<template>
  <div class="comment">
    <div
      v-if="versionData"
      v-ie-placeholder
      class="comment-content"
    >
      <textarea
        id="cotext"
        ref="textarea"
        v-model="comment"
        class="comment-textarea"
        :placeholder="`${$t('请输入版本说明, 最多可输入200个字符或汉字')}`"
        @keyup="handler"
      />
      <div
        class="count"
        :class="warn?'warn':''"
      >
        {{ textCount }}/200
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['versionData'],
  data() {
    return {
      textCount: 0, // 字符数量
      warn: false, // 提示
      comment: '', // 版本描述
      maxlength: 200, // 允许输入的长度
    }
  },
  watch: {
    versionData: {
      handler(n, o) {
        this.comment = this.versionData.comment
        this.textCount = (this.comment && this.comment.length) || 0
      },
      deep: true,
    },
  },
  mounted() {
    this.comment = this.versionData.comment
    this.textCount = (this.comment && this.comment.length) || 0
  },
  methods: {
    /**
             * 检验字符的方法
             */
    handler() {
      this.textCount = this.$refs.textarea.value.length || 0
      if (this.textCount > this.maxlength) {
        this.textCount = this.maxlength
        this.comment = this.$refs.textarea.value.slice(0, this.maxlength)
        this.warn = true
      } else if (this.textCount == this.maxlength) {
        this.warn = true
      } else {
        this.warn = false
      }
    },
  },
}
</script>

<style scoped lang="less">
.comment{
  .comment-content {
    position: relative;
    .count {
      font-size: 12px;
      position: absolute;
      color: #929ca9;
      right: 24px;
      bottom: 10px;
      cursor: auto;
      #length {
        display: inline-block;
        width: 30px;
        text-align: right;
      }
    }
  }
  .comment-textarea {
    width: 100%;
    height:280px;
    font-size: 14px;
    padding: 26px 24px;
    border-top: none;
    border-left: none;
    border-right: none;
    resize: none;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid #e6e6e6;
    outline: none;
  }
  .warn{
    color: red!important;
  }
}
</style>
